import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('body').removeClass('menu-is-open');
    console.log('menu-opener')
    $('body').on('click','.px-menu-opener',function(){
        if($(this).hasClass('closer')){
            $('body').removeClass('menu-is-open');
        }else{
            $('body').addClass('menu-is-open');
        }
    })
})